import i18n from "src/i18n/config";
import { getOrganizationUrlValidationError } from "src/ui/utils/validityChecker";
import { z } from "zod";

const maxCharactersLength = 64;

const maxLengthMessage = (field: "name" | "organizationName" | "organizationVatId") =>
    i18n.t(`pages:workspacePage.input.${field}.validation.maxLength`, { maxCharactersLength });

const nameEmptyMessage = i18n.t("pages:workspacePage.input.name.validation.empty");

const optionalBoundedText = (field: "organizationName" | "organizationVatId") =>
    z.string().max(maxCharactersLength, maxLengthMessage(field)).optional();

export const workspaceDetailsValidationSchema = z.object({
    name: z
        .string({ error: nameEmptyMessage })
        .max(maxCharactersLength, maxLengthMessage("name"))
        .refine((value) => Boolean(value.trim()), nameEmptyMessage),
});

export const organizationDetailsValidationSchema = z.object({
    organizationName: optionalBoundedText("organizationName"),
    organizationVatId: optionalBoundedText("organizationVatId"),
    organizationUrl: z
        .string()
        .optional()
        .superRefine((value, ctx) => {
            const error = getOrganizationUrlValidationError(value?.trim() ?? "");
            if (error) {
                ctx.addIssue({
                    code: "custom",
                    message: i18n.t(`common:validation.url.${error}`),
                });
            }
        }),
});

export type WorkspaceDetailsFormValues = z.infer<typeof workspaceDetailsValidationSchema>;
export type OrganizationDetailsFormValues = z.infer<typeof organizationDetailsValidationSchema>;
